import { AppConfig } from '../app/models/app.model';
import * as devEnv from './config.DEV';
import * as localEnv from './config.LOCAL';

function getConfig(): AppConfig {
  if (devEnv.domains.includes(window.location.hostname) && window.location.href.startsWith(devEnv.href)) {
    return devEnv.config;
  }
  console.warn(`Environment not configured!`);
  return localEnv.config;
}

export const environment: AppConfig & { production: boolean } = {
  production: true,
  apiGateway: getConfig().apiGateway,
  env: getConfig().env,
  appName: getConfig().appName,
};
